<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
    <path d="M10.6467 0.900648C10.4321 0.818575 10.1884 0.87257 10.0319 1.03456L7.83638 3.74514L5.98069 0.265659C5.88008 0.101512 5.69898 0 5.5 0C5.30102 0 5.11768 0.101512 5.01931 0.265659L3.16362 3.74514L0.968089 1.03672C0.811585 0.87473 0.567886 0.820734 0.353252 0.902808C0.140854 0.982721 0 1.18143 0 1.40389V8.59611C0 9.36933 0.652846 10 1.45325 10H9.54675C10.3472 10 11 9.36933 11 8.59611V1.40389C11 1.18143 10.8591 0.982721 10.6467 0.900648Z" fill="url(#paint0_linear_22890_35699)" fill-opacity="0.5"/>
    <defs>
      <linearGradient id="paint0_linear_22890_35699" x1="10.7458" y1="9.19679" x2="0.256685" y2="0.805483" gradientUnits="userSpaceOnUse">
        <stop stop-color="#AF4C0B"/>
        <stop offset="1" stop-color="#FFB180"/>
      </linearGradient>
    </defs>
  </svg>
</template>
